import { useEffect, useRef } from 'react';
import { Button } from '@/shared/ui';

interface SessionRecordingPromptProps {
    onAccept: () => void;
    onDecline: () => void;
}

export const SessionRecordingPrompt = ({ onAccept, onDecline }: SessionRecordingPromptProps) => {
    const sessionRecordingRef = useRef<HTMLDivElement>(null);

    // useEffect(() => {
    //     const handleOutsideClick = (e: MouseEvent) => {
    //         if (sessionRecordingRef.current && !sessionRecordingRef.current.contains(e.target as Node)) {
    //             onDecline();
    //         }
    //     };
    //     document.addEventListener('mousedown', handleOutsideClick);
    //     return () => document.removeEventListener('mousedown', handleOutsideClick);
    // }, [onDecline]);

    return (
        <div className="fixed bottom-0 left-0 sm-max:right-0 sm:left-2 z-[999] flex justify-center pointer-events-none">
            <div
                ref={sessionRecordingRef}
                className="pointer-events-auto w-full max-w-[520px] mx-4 mb-[80px] sm:mb-4 border-[3px] rounded-2xl border-mint-400"
            >
                <div className="bg-white rounded-[14px] border border-primary-700 shadow-consentPopup p-[1.5rem]">
                    <div className="flex flex-col gap-[8px] text-primary-900 text-left font-normal">
                        <p className="font-agrandir font-normal text-24 leading-[32px] text-primary-900">Let's improve MedBox together</p>
                        <span data-testid="session-record-content" className="font-atkinsonHyperlegible font-normal text-16 leading-[130%] tracking-[0.16px] text-primary-900">
                            Enable session recording to help us improve your experience.{' '}
                            <a
                                target="_blank"
                                className="cursor-pointer font-dmSansBold underline"
                                href="https://medbox.com/cookie-policy/"
                                style={{ fontWeight: '700' }}
                            >
                                Cookie Policy
                            </a>
                        </span>
                    </div>
                    <div className="flex flex-row gap-2 justify-between sm:justify-end mt-[20px]">
                        <div className='px-[16px] flex flex-1 sm:flex-none items-center justify-center'>
                            <Button
                                variant="text"
                                onClick={onDecline}
                                testId="button-session-recording-decline"
                                className="w-full sm:w-fit"
                                fontClassName="font-dmSansBold font-bold underline text-17 leading-[130%] "
                            >
                                Not now
                            </Button>
                        </div>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={onAccept}
                            testId="button-session-recording-accept"
                            className="flex-1 sm:flex-none sm:w-fit px-[40px]"
                            fontClassName="font-dmSansMedium font-bold"
                        >
                            Allow
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
